import { render, staticRenderFns } from "./details_ymzyy.vue?vue&type=template&id=3dcc3526"
import script from "./details_ymzyy.vue?vue&type=script&lang=js"
export * from "./details_ymzyy.vue?vue&type=script&lang=js"
import style0 from "./details_ymzyy.vue?vue&type=style&index=0&id=3dcc3526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports